'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationEventsController = function ConfigurationEventsController($scope, $q, dataRetriever, configurationEvents, hepService, $log) {
  var CONFLICT_ERROR_CODE = 409;
  dataRetriever.getDataRetriever('EVENTS_SCREEN', 'configuration-events-mode').setCustomSearchCriteriaRules([]);
  function reloadData() {
    $scope.$broadcast('grid:dataChanged');
    hepService.loadSpecialEvents();
  }
  function validate(rows) {
    _.each(rows, function (row) {
      if (row.hasOwnProperty('eventName') === false) {
        throw new Error('\'Event name\' can not be empty.');
      }
      if (row.eventName.length > 40) {
        throw new Error('\'Event name\' can\'t be longer than 40 chars.');
      }
      if (row.hasOwnProperty('eventType') === false) {
        throw new Error('\'Event type\' can not be empty.');
      }
    });
  }
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationEventsController: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicate record exists');
    } else {
      var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationEventsController: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  $scope.saveChanges = function (event, rows) {
    try {
      validate(rows);
      configurationEvents.save(rows).then(postColumnsSuccessHandler, postColumnsErrorHandler).then(reloadData);
    } catch (e) {
      toastr.error(e);
    }
  };
};
ConfigurationEventsController.$inject = ['$scope', '$q', 'DataRetrieverService', 'ConfigurationEventsService', 'HepService', '$log'];
module.exports = ConfigurationEventsController;